import { OffersCommerceInfoResponse } from '@sxm-de/dev-kits/microservices-sdk/types';

export interface OffersCommerceInfoRequest {
    offerIds: string[];
    locales: string[];
    accessToken: string;
    province?: string;
}

export type GetOffersCommerceInfoFn = (
    payload: OffersCommerceInfoRequest,
) => Promise<OffersCommerceInfoResponse>;

export function initGetOffersCommerceInfoFn({
    baseUrl,
}: {
    baseUrl: string;
}): GetOffersCommerceInfoFn {
    return async ({
        accessToken,
        offerIds,
        locales,
        province,
    }: OffersCommerceInfoRequest) => {
        const url = `${baseUrl}/offers/commerce/info`;
        const headers = {
            Accept: 'application/json; charset=utf-8',
            'Content-Type': 'application/json',
        };
        const response = await fetch(`${url}`, {
            method: 'POST',
            headers,
            credentials: 'include',
            body: JSON.stringify({
                offerIds,
                ...(province ? { province } : {}),
                locales: locales.map((locale) =>
                    normalizeLangToLocaleForRequest(locale),
                ),
                accessToken,
            }),
        });
        const { data } = await response.json();
        return {
            locales: data.locales.reduce(
                (items: any, { locale, offerInfos }: any) => {
                    return {
                        ...items,
                        [normalizeLangToLocaleForResponse(locale)]: offerInfos,
                    };
                },
                {},
            ),
        };
    };
}

const normalizeLangToLocaleForRequest = (locale: string): string => {
    return locale?.replace('-', '_');
};

const normalizeLangToLocaleForResponse = (locale: string): string => {
    return locale?.replace('_', '-');
};
